import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import img1 from '../assests/previousWorks/01-OverHeadGlazing.jpg';
import img2 from '../assests/previousWorks/02-MtechnoGraphic.jpg';
import img3 from '../assests/previousWorks/03-MtechnoDesign.jpg';
import img5 from '../assests/previousWorks/05-Batman.jpg';
import img6 from '../assests/previousWorks/06-Hirakud.jpg';
import img7 from '../assests/previousWorks/07-Deadpool.jpg';
import img8 from '../assests/previousWorks/08-IBillSolution.jpg';
import img9 from '../assests/previousWorks/09-SavvysBarGrill.jpg';
import img10 from '../assests/previousWorks/10-Bestof10DesiKitchen.jpg';

const Previousworks = () => {
    const images = [
        { src: img1, altText: 'Van Graphic Design' },
        { src: img2, altText: 'Mtechno Graphic Design' },
        { src: img3, altText: 'Mtechno Graphic Design' },

        { src: img5, altText: 'Minimalistic Batmat Wallpaper' },
        { src: img6, altText: '3D Graphic Design' },
        { src: img7, altText: 'Minimalistic Deadpool Wallpaper' },
        { src: img8, altText: 'Logo Design for I-Bill Solution' },
        { src: img9, altText: 'Logo Deisgn for Savvy Bar Grill' },
        { src: img10, altText: 'Logo Deisgn for Youtube Channel Best of 10 Desi Kitchen' }
    ];

    const adobeStock = [
        {fileID:"1835463774", image:"https://as2.ftcdn.net/v2/jpg/18/35/46/37/1000_F_1835463774_oP4QJQ3hMf6fVTeXW8QcYLQUMaWBi5t7.jpg"},
        {fileID:"675043048", image:"https://as1.ftcdn.net/v2/jpg/06/75/04/30/1000_F_675043048_2OLOfzWHrCDpm7rhvPtbgty3GA46VrBa.jpg"},
        {fileID:"635130951", image:"https://as2.ftcdn.net/v2/jpg/06/35/13/09/1000_F_635130951_Eso0f7pHnVDHYIMXnMCdJf0txfUjJRWx.jpg"},
        {fileID:"1836734572", image:"https://as2.ftcdn.net/v2/jpg/18/36/73/45/1000_F_1836734572_kExqcg8iDTPjsin1Nc3d3TzUopuUghOB.jpg"},
        {fileID:"1760348695", image:"https://v.ftcdn.net/17/60/34/86/700_F_1760348695_8wRigf2nZxs4DECWBGyx78BQknPSnc91_ST.mp4"},
        {fileID:"1375504172", image:"https://as2.ftcdn.net/v2/jpg/13/75/50/41/1000_F_1375504172_hBx2Vzt2jbhG28Qp287Fe4bLZyDgMTtL.jpg"},
        {fileID:"1282462876", image:"https://as1.ftcdn.net/v2/jpg/12/82/46/28/1000_F_1282462876_lUZDN0q4N1oPdTQpPxISuo1eXsARdFim.webp"},
        {fileID:"1274155145", image:"https://as2.ftcdn.net/v2/jpg/12/74/15/51/1000_F_1274155145_4jvZkbsm8qBSp0PdMEi6g9kOTndWA1Xx.webp"},
        {fileID:"1220669830", image:"https://as1.ftcdn.net/v2/jpg/12/20/66/98/1000_F_1220669830_1jV1COx7s3OeiPcyARA5m3P3g1nlXIcT.webp"},
    ]
    return (
        <>
            <Navigation />
           

            
             <div className="container">
                <div className='button-container'>
                    <span className='button outline'>My Works on Adobe Stock</span>
                </div>
                <div className='image-container'>
                    {adobeStock.map((file, index) => (
                        <div className='image-item' onClick={()=> window.open("https://stock.adobe.com/in/stock-photo/id/"+file.fileID, "_blank")}>
                            <embed src={file.image} style={{width:'100%'}}/>
                        </div>
                    ))}
                </div>
            </div>
             <div className="container">
                <div className='button-container'>
                    <span className='button outline'>My Freelancing works</span>
                </div>
                <div className='image-container'>
                    {images.map((file, index) => (
                        <div className='image-item'>
                            <img key={index} src={file.src} alt={file.altTex} style={{width:'100%'}} />
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Previousworks;